export default "__VITE_ASSET__CF$I56Ip__"